import { render, staticRenderFns } from "./resourceImage1.vue?vue&type=template&id=6b68a262&scoped=true"
import script from "./resourceImage1.vue?vue&type=script&lang=js"
export * from "./resourceImage1.vue?vue&type=script&lang=js"
import style0 from "./resourceImage1.vue?vue&type=style&index=0&id=6b68a262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b68a262",
  null
  
)

export default component.exports